class MarketSnapshotService {
  constructor() {
    // this.apiBase = "https://beta.infomanav.in/keep/zerodhaAPI/api.php";
    this.apiBase = "https://pmsapi.infomanav.in/api/v1/FNO";;
    this.debugEnabled = false;
  }

  setDebug(enabled) {
    this.debugEnabled = !!enabled;
  }

  debug(...args) {
    if (!this.debugEnabled) return;
    console.log("[MARKET-SNAPSHOT]", ...args);
  }

  getSharedData() {
    try {
      return JSON.parse(localStorage.getItem("sharedData") || "null");
    } catch (_) {
      return null;
    }
  }

  getAuthFromStorage() {
    const shared = this.getSharedData() || {};
    const accessToken =
      shared.accessToken || shared.AccessToken || localStorage.getItem("accessToken");
    const clientCode =
      shared.ClientCode || shared.clientCode || localStorage.getItem("ClientCode");
    const apiKey =
      shared.api_key || shared.apiKey || localStorage.getItem("api_key");

    if (!accessToken || !clientCode || !apiKey) {
      throw new Error(
        "Missing local auth values: accessToken / ClientCode / api_key",
      );
    }

    return {
      accessToken: String(accessToken),
      clientCode: String(clientCode),
      apiKey: String(apiKey),
    };
  }

  normalizeStocks(stocks = []) {
    return (Array.isArray(stocks) ? stocks : [])
      .map((item) => {
        const exchange = String(item?.Exchange ?? item?.Exch ?? "").charAt(0);
        const exchangeType = String(
          item?.ExchangeType ?? item?.ExchType ?? "",
        ).charAt(0);
        const scripCode = String(
          item?.ScripCode ?? item?.scripCode ?? item?.Token ?? "",
        ).trim();

        if (!exchange || !exchangeType || !scripCode) return null;

        return {
          Exchange: exchange,
          ExchangeType: exchangeType,
          ScripCode: scripCode,
        };
      })
      .filter(Boolean);
  }

  async getMarketSnapshot(stocks = [], options = {}) {
    const normalizedStocks = this.normalizeStocks(stocks);
    if (!normalizedStocks.length) {
      throw new Error("stocks is required with Exchange, ExchangeType, ScripCode");
    }

    const { accessToken, clientCode, apiKey } = this.getAuthFromStorage();
    const payload = {
      accessToken,
      apiKey,
      clientCode,
      stocks: normalizedStocks,
    };

    this.debug("request", payload);

    const response = await fetch(`${this.apiBase}?xAction=getMarketSnapshot`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      signal: options?.signal,
    });

    let data = null;
    try {
      data = await response.json();
    } catch (_) {
      throw new Error("Invalid JSON response from getMarketSnapshot");
    }

    this.debug("response", data);

    if (!response.ok) {
      throw new Error(`getMarketSnapshot failed with HTTP ${response.status}`);
    }

    const status = String(data?.status || "").toLowerCase();
    if (status && status !== "success") {
      throw new Error(data?.message || "getMarketSnapshot returned non-success");
    }

    return data;
  }
}

const marketSnapshotService = new MarketSnapshotService();

export default marketSnapshotService;
